import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'
import Header from '../../components/header'
import Layout from '../../components/layout'
import Tabs from '../../components/tabs'
import Ingredients from '../ingredients'
import Recipes from '../recipes'

import Admin from '../admin'
import LoginOverlay from '../login/loginOverlay'

import { isAdmin } from '../../common/roles'

import S from './styled'

const empty = () => <div>not implemented yet</div>

const MainPage = ({ history, role, match: { params: { page } } }) => {

  const tabs = useMemo(() => [{
    label: 'Recipes Library',
    value: 'recipes',
    component: Recipes,
  },{
    label: 'Ingredients Library',
    value: 'ingredients',
    component: Ingredients,
  }, isAdmin(role) ? {
    label: 'Admin',
    value: 'admin',
    component: Admin,
  } : null].filter(Boolean), [role])

  return (
    <S.MainPage id="main-content">
      <Header />
      <Layout>
        <Tabs onChange={newPage => history.push(`/${newPage}`)} selected={page} tabs={tabs} fullHeight>
          <Switch>
            {
              tabs.map(tab => (
                <Route
                  key={tab.value}
                  path={`/${tab.value}`}
                  component={tab.component || empty}
                />
              ))
            }
            <Redirect to={`/${tabs[0].value}`}/>
          </Switch>
        </Tabs>
      </Layout>
      <LoginOverlay />
    </S.MainPage>
  )
}

const mapStateToProps = state => ({
  role: state.session.role,
})


export default connect(mapStateToProps)(withRouter(MainPage))
